// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { SurveyInfoResponseDTO } from "../../../../../api/backend-openapi";
import configuration from "../../../../../utils/Config";
import { downloadFile } from "../../../../../utils/FileUtils";

export interface SurveyExcelResultsButtonProps {
  surveyDetails: SurveyInfoResponseDTO;
}

const excelUrl = configuration.backendBaseUrl + "/survey/detailedResponses/";

const SurveyExcelResultsButton: React.FunctionComponent<SurveyExcelResultsButtonProps> = (
  props: SurveyExcelResultsButtonProps
) => {
  const { surveyDetails } = props;
  const { t } = useTranslation();

  const downloadButton = (
    <Button
      type="default"
      className="btn-secondary m-2"
      onClick={() => downloadFile(`${excelUrl}${surveyDetails.id}.xlsx`)}
    >
      <DownloadOutlined />
      {t("detail_survey.download_results")}
    </Button>
  );

  return <>{downloadButton}</>;
};

export default SurveyExcelResultsButton;
